module.exports = __webpack_public_path__ + "img/denied.4e7ef987.png";